if (!customElements.get('card-product-swatches')) {
  customElements.define(
    'card-product-swatches',
    class CardProductSwatches extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('.product-card-wrapper');
        if (!this.card) return;

        this.buttons = this.querySelectorAll('[data-card-swatch]');
        this.primaryImage = this.card.querySelector('[data-card-primary-image]');
        this.price = this.card.querySelector('.price');
        this.links = this.card.querySelectorAll('a.full-unstyled-link');

        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const button = event.target.closest('[data-card-swatch]');
        if (!button || !this.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();
        this.select(button);
      }

      select(button) {
        this.buttons.forEach((item) => {
          item.setAttribute('aria-checked', item === button ? 'true' : 'false');
        });

        if (this.primaryImage) {
          const { src, srcset, alt, width, height } = button.dataset;
          if (src) this.primaryImage.src = src;
          if (srcset) this.primaryImage.srcset = srcset.trim();
          if (alt) this.primaryImage.alt = alt;
          if (width) this.primaryImage.width = width;
          if (height) this.primaryImage.height = height;
        }

        const url = button.dataset.variantUrl;
        if (url) {
          this.links.forEach((link) => {
            link.href = url;
          });
        }

        this.updatePrice(button);
      }

      plainText(value) {
        if (!value) return '';
        const template = document.createElement('template');
        template.innerHTML = value;
        return (template.content.textContent || '').trim();
      }

      updatePrice(button) {
        if (!this.price) return;

        const price = this.plainText(button.dataset.price);
        const comparePrice = this.plainText(button.dataset.comparePrice);
        const priceAmount = Number(button.dataset.priceAmount || 0);
        const compareAmount = Number(button.dataset.compareAmount || 0);
        const onSale = Boolean(comparePrice) && compareAmount > priceAmount;
        const soldOut = button.dataset.available === 'false';

        this.price.classList.toggle('price--on-sale', onSale);
        this.price.classList.toggle('price--sold-out', soldOut);

        const regular = this.price.querySelector('.price__regular .price-item--regular');
        const salePrice = this.price.querySelector('.price__sale .price-item--sale');
        const saleCompare = this.price.querySelector('.price__sale s.price-item--regular');

        if (regular && price) regular.textContent = price;
        if (salePrice && price) salePrice.textContent = price;
        if (saleCompare && comparePrice) saleCompare.textContent = comparePrice;
      }
    }
  );
}
